<template lang="html">
  <header>
    <h1>{{ name }} <span v-if="count" class="chip">{{ count }}</span></h1>
  </header>
</template>

<script>
export default {
  props: ['name', 'count']
}
</script>

<style lang="scss">
header {
  text-align: center;

  h1 {
    text-transform: uppercase;
    font-size: 22px;
    font-weight: bold;

    .chip {
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Partial/PageHeader.vue